(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        "use strict";
        var __webpack_exports__ = {};
        __webpack_require__.r(__webpack_exports__);
    }();
    !function() {
        (() => {
            if (window.erk_cvg) {
                return;
            }
            window.erk_cvg = true;
            const ROOT_SELECTOR = "[data-erk-cvg]";
            const MOBILE_QUERY = window.matchMedia("(max-width: 699px)");
            const rootInstances = new WeakMap;
            function getMobileElements(root) {
                const swiperEl = root.querySelector(".erk-cv-grid__mob-swiper");
                const paginationEl = root.querySelector(".erk-cv-grid__pager");
                const slideCount = swiperEl ? swiperEl.querySelectorAll(".swiper-slide").length : 0;
                return {
                    swiperEl: swiperEl,
                    paginationEl: paginationEl,
                    slideCount: slideCount
                };
            }
            function destroySwiper(root) {
                const instance = rootInstances.get(root);
                if (!instance || !instance.swiper) {
                    return;
                }
                instance.swiper.destroy(true, true);
                instance.swiper = null;
            }
            function initSwiper(root) {
                const instance = rootInstances.get(root);
                const elements = getMobileElements(root);
                if (!instance || !elements.swiperEl || !elements.paginationEl) {
                    return;
                }
                if (instance.swiper || typeof Swiper === "undefined" || elements.slideCount <= 1) {
                    return;
                }
                instance.swiper = new Swiper(elements.swiperEl, {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 0,
                    speed: 400,
                    watchOverflow: true,
                    pagination: {
                        el: elements.paginationEl,
                        clickable: true
                    }
                });
            }
            function syncRoot(root) {
                if (MOBILE_QUERY.matches) {
                    initSwiper(root);
                    return;
                }
                destroySwiper(root);
            }
            function bindRoot(root) {
                if (!root || rootInstances.has(root)) {
                    return;
                }
                const onBreakpointChange = function() {
                    syncRoot(root);
                };
                rootInstances.set(root, {
                    swiper: null,
                    onBreakpointChange: onBreakpointChange
                });
                if (typeof MOBILE_QUERY.addEventListener === "function") {
                    MOBILE_QUERY.addEventListener("change", onBreakpointChange);
                } else if (typeof MOBILE_QUERY.addListener === "function") {
                    MOBILE_QUERY.addListener(onBreakpointChange);
                }
                syncRoot(root);
            }
            function unbindRoot(root) {
                const instance = rootInstances.get(root);
                if (!instance) {
                    return;
                }
                destroySwiper(root);
                if (typeof MOBILE_QUERY.removeEventListener === "function") {
                    MOBILE_QUERY.removeEventListener("change", instance.onBreakpointChange);
                } else if (typeof MOBILE_QUERY.removeListener === "function") {
                    MOBILE_QUERY.removeListener(instance.onBreakpointChange);
                }
                rootInstances.delete(root);
            }
            function initAll(scope) {
                const searchScope = scope || document;
                const roots = searchScope.querySelectorAll(ROOT_SELECTOR);
                roots.forEach((function(root) {
                    bindRoot(root);
                }));
            }
            function destroyAll(scope) {
                const searchScope = scope || document;
                const roots = searchScope.querySelectorAll(ROOT_SELECTOR);
                roots.forEach((function(root) {
                    unbindRoot(root);
                }));
            }
            function registerEvents() {
                if (document.readyState !== "loading") {
                    initAll(document);
                } else {
                    document.addEventListener("DOMContentLoaded", (function() {
                        initAll(document);
                    }));
                }
                document.addEventListener("shopify:section:load", (function(event) {
                    if (event && event.target) {
                        initAll(event.target);
                    }
                }));
                document.addEventListener("shopify:section:unload", (function(event) {
                    if (event && event.target) {
                        destroyAll(event.target);
                    }
                }));
            }
            registerEvents();
        })();
    }();
})();